export class FeaturePermission {
  public enableCampaign: boolean;
  public enableCommunication: boolean;
  constructor (enableCampaign: boolean, enableCommunication: boolean) {
    this.enableCampaign = enableCampaign;
    this.enableCommunication = enableCommunication;
  }
}



// WEBPACK FOOTER //
// ./src/models/influencer/feature-permission.ts